<template>
	<div>
		<md-button class="md-fab md-primary md-fab-bottom-right md-fixed" @click.prevent="open=!open">
			<md-icon>edit</md-icon>
		</md-button>

		<md-dialog :md-active.sync="open" :md-fullscreen="false" :md-backdrop="false" style="min-width:320px;">
			<md-dialog-title>コメント投稿</md-dialog-title>
			<md-dialog-content>
				<md-field>
					<label>ニックネーム</label>
					<md-input v-model="comment.user_name" maxlength="30"></md-input>
				</md-field>
				<md-field>
					<label>内容</label>
					<md-textarea v-model="comment.body" required maxlength="500"></md-textarea>
				</md-field>
			</md-dialog-content>
			<md-dialog-actions>
				<md-button class="" @click="open=false">閉じる</md-button>
				<md-button v-show="!loading" class="md-primary" @click="clickCreateExec()">投稿する</md-button>
				<md-button v-show="loading">
					<md-progress-spinner :md-diameter="20" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
				</md-button>
			</md-dialog-actions>
		</md-dialog>
	</div>
</template>

<script>
import axios from 'axios'
export default {
	name: 'CreateComment',
	data: ()=>{
		return {
			open : false,
			loading: false,
			comment : {
				user_name : localStorage.user_name||"",
				body : "",
				topic_id: null,
			}
		}
	},
	watch : {
		comment : {
			handler: function(val){
				localStorage.user_name = val.user_name;
			},
			deep: true,
		},
	},
	props: {},
	methods : {
		// ダイアログオープン（親から呼ぶ用）
		openDialog : function ( def = "" ) {
			this.comment.body = def;
			this.open = true;
		},
		// 作成ボタンがクリックされた.
		clickCreateExec : function(){
			this.loading = true;
			axios.post('https://9kzgu3ix6l.execute-api.ap-northeast-1.amazonaws.com/main/comment', this.comment)
				.then(()=>{
					// 成功.
					this.$root.$emit("reload-CommentList");//一覧を更新.
					this.loading = false;
					this.open = false;
					this.comment.body = "";
				})
				.catch(( error )=>{
					// console.log("err");
					if ( error.response.status < 500 ) {
						alert("コメントの投稿に失敗しました\n入力内容をお確かめ下さい");
					} else {
						alert("コメントの投稿に失敗しました\n時間を置いてお試しください");
					}
					this.loading = false;
				})
		},
	},
	created : function(){
		// スレッドIDをセットしておく.
		this.comment.topic_id = this.$route.params.topic_id;
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
